import { Component } from '@angular/core';

@Component({
  selector: 'opac-card-item-social',
  templateUrl: './card-item-social.component.html',
  styleUrls: ['./card-item-social.component.scss']
})
export class CardItemSocialComponent {
}
